import React from 'react';
import '../../styles/money.css';
import RequireEvent from '../../components/RequireEvent';
import { choose } from '../../utils/platform';
import { useLabelSetup } from './useLabelSetup';
import LabelSetupDesktop from './LabelSetup.desktop';
import LabelSetupMobile from './LabelSetup.mobile';

const LabelSetupView = choose(LabelSetupDesktop, LabelSetupMobile);

function LabelSetupInner({ event }) {
  const vm = useLabelSetup(event);
  return <LabelSetupView vm={vm} />;
}

export default function LabelSetup() {
  return <RequireEvent>{(event) => <LabelSetupInner event={event} />}</RequireEvent>;
}
